import { Products } from '../enums';

export const useProductGtmPayload = () => {
  return { productGtmPayload: Products.Marketplace };
};
